import { formatLabel, optionsHorizontalBar } from "./utils"

const cd_training_income = {
  figureNumber: "2.6",
  title: "Participant Region of Origin",
  subTitle: "FY 2022 (number of participants)",
  source: "Sources: IMF, Participant and Applicant Tracking System; and IMF staff calculations. /n Note: Most of the IMF’s training falls under the Institute for Capacity Development (ICD) Training Program, which includes training coordinated by ICD and delivered by ICD and other departments at IMF headquarters and globally at the IMF’s Regional Capacity Development Centers and in programs for country officials. Training also includes IMF online courses successfully completed by country officials. In addition, training is provided by functional departments outside the ICD Training Program. For definitions of country income groups, see the note to Figure 2.3.",
  data: {
    labels: [
      formatLabel("Emerging market and middle-income economies", 30),
      formatLabel("Low-income developing countries", 30),
      formatLabel("Advanced economies", 30),
    ],
    datasets: [
      {
        label: "",
        data: [12603, 8446, 1557],
        backgroundColor: "#E7792B",
      },
    ],
  },
  options: optionsHorizontalBar,
}

export default cd_training_income;